import { StateCreator } from 'zustand';

import { Store } from '../models';
import { CombinedSlices } from '.';

export interface StoreSlice {
  company_name: string;
  store: Store | null; // Set as the first store
  stores: Store[] | null;
  setStores: (s: Store[] | null) => void;
}

export const createStoreSlice: StateCreator<
  CombinedSlices,
  [],
  [],
  StoreSlice
> = (set) => ({
  stores: null,
  store: null,
  company_name: "",
  setStores: (s: Store[] | null) => set(() => ({ stores: s, store: s ? s[0] : null })),
});
